import React from "react";

export const typeCatProvider = {
    getOptions,
    getItem,
};

const typeOptions = [
    {
        id: 'List',
        value: 'List',
        label: <div><label>{'List'}</label></div>
    }, {
        id: 'Map',
        value: 'Map',
        label: <div><label>{'Map'}</label></div>
    }
];

async function getOptions(){
    try {
        return ( typeOptions );

    } catch (error) {
        throw error;
    }
}

async function getItem(id){
    try {
        return ( typeOptions[id] );
    } catch (error) {
        throw error;
    }
}